// ScrollToTop.tsx - Scrolls to top on route navigation
// TODO: Consider adding smooth scroll option for specific transitions

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Gate debug logging behind NODE_ENV for development use only
const debugLog = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    debugLog('[DEBUG ScrollToTop] Navigated to:', pathname);
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
